// src/components/session-operations-provider/session-operations-provider.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment EGDSActionDialogFooterFragment on EGDSDialogFooter {\n    ... on EGDSStackedDialogFooter {\n      buttons {\n        ...PackageUIActionDialogFooterButton\n      }\n    }\n    ... on EGDSInlineDialogFooter {\n      buttons {\n        ...PackageUIActionDialogFooterButton\n      }\n    }\n  }\n\n  fragment PackageUIActionDialogFooterButton on EGDSButton {\n    primary\n    ... on PackageUIActionDialogFooterButton {\n      style\n      dialogAction {\n        ... on PackageUIActionDialogFooterButtonCloseAction {\n          analytics {\n            referrerId\n            linkName\n          }\n        }\n        ... on PackageUIActionDialogSearchLinkAction {\n          newTabAccessibilityText\n          analytics {\n            referrerId\n            linkName\n          }\n          resource {\n            ... on HttpURI {\n              relativePath\n            }\n          }\n          target\n        }\n      }\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSHeadingFragment on EGDSHeading {\n    text\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n    size\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    theme\n    weight\n    decorative\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    text\n    action {\n      accessibility\n      target\n      resource {\n        value\n      }\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n    icon {\n      id\n    }\n    iconPosition\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextItemFragment on EGDSSpannableTextItem {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    inlineContent {\n      ...EGDSSpannableTextItemFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSHeadingFragment\n    ...EGDSParagraphFragment\n    ...EGDSPlainTextFragment\n    ...EGDSStandardLinkFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSSpannableTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n    spotLight\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment PackageUIEmptyStateErrorFragment on PackageUIEmptyStateError {\n    icon {\n      ...EGDSIconFragment\n    }\n    primary {\n      ...EGDSHeadingFragment\n    }\n    secondaries {\n      ...EGDSTextFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment MishopUIOperationFailureDialogFragment on MishopUIOperationFailureDialog {\n    content {\n      text\n    }\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      footer {\n        ...EGDSActionDialogFooterFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment MultiItemSearchContextErrorResponseFragment on MultiItemSearchContextErrorResponse {\n    message\n    failureDialog {\n      ...MishopUIOperationFailureDialogFragment\n    }\n    errorContent {\n      ...PackageUIEmptyStateErrorFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  mutation MishopSharedUIAddProductMutation(\n    $context: ContextInput!\n    $multiItemSessionId: String!\n    $activities: [ActivityNaturalKeyInput!]\n    $groundTransfers: [GroundTransfersNaturalKeyInput!]\n  ) {\n    multiItemShopping(context: $context) {\n      addProducts(sessionId: $multiItemSessionId, activities: $activities, groundTransfers: $groundTransfers) {\n        __typename\n        ... on MultiItemSearchContextCreatedResponse {\n          redirectUrl\n          action {\n            __typename\n            shoppingContext {\n              multiItem {\n                id\n              }\n            }\n            ... on FlightSearchMultiItemShoppingAction {\n              journeyContinuationId\n            }\n          }\n          message\n        }\n        ... on MultiItemSearchContextErrorResponse {\n          ...MultiItemSearchContextErrorResponseFragment\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  mutation MishopSharedUIChangeSelectedProductMutation(\n    $context: ContextInput!\n    $sessionId: String!\n    $priceToken: String!\n    $properties: [PropertyNaturalKeyInput!]\n    $cars: [CarNaturalKeyInput!]\n    $flights: [FlightNaturalKeyInput!]\n    $changeAction: MultiItemShoppingActionType!\n  ) {\n    multiItemShopping(context: $context) {\n      changeSelectedProduct(\n        sessionId: $sessionId\n        priceToken: $priceToken\n        properties: $properties\n        cars: $cars\n        flights: $flights\n        changeAction: $changeAction\n      ) {\n        __typename\n        ... on MultiItemSearchContextCreatedResponse {\n          shoppingContext {\n            multiItem {\n              id\n              packageType\n            }\n          }\n          redirectUrl\n        }\n        ... on MultiItemSearchContextErrorResponse {\n          message\n        }\n      }\n    }\n  }\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  mutation MishopSharedUIRemoveProductMutation(\n    $context: ContextInput!\n    $multiItemSessionId: String!\n    $activities: [ActivityNaturalKeyInput!]\n    $groundTransfers: [GroundTransfersNaturalKeyInput!]\n  ) {\n    multiItemShopping(context: $context) {\n      removeProducts(sessionId: $multiItemSessionId, activities: $activities, groundTransfers: $groundTransfers) {\n        __typename\n        ... on MultiItemSearchContextCreatedResponse {\n          redirectUrl\n          action {\n            __typename\n            shoppingContext {\n              multiItem {\n                id\n              }\n            }\n            ... on FlightSearchMultiItemShoppingAction {\n              journeyContinuationId\n            }\n          }\n          message\n        }\n        ... on MultiItemSearchContextErrorResponse {\n          ...MultiItemSearchContextErrorResponseFragment\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  mutation MishopSharedUIReplaceProductMutation(\n    $context: ContextInput!\n    $multiItemSessionId: String!\n    $priceToken: String\n    $cars: [CarNaturalKeyInput!]\n    $flights: [FlightNaturalKeyInput!]\n    $properties: [PropertyNaturalKeyInput!]\n  ) {\n    multiItemShopping(context: $context) {\n      selectProducts(sessionId: $multiItemSessionId, priceToken: $priceToken, cars: $cars, flights: $flights, properties: $properties) {\n        __typename\n        ... on MultiItemSearchContextCreatedResponse {\n          redirectUrl\n          action {\n            __typename\n            shoppingContext {\n              multiItem {\n                id\n              }\n            }\n            ... on FlightSearchMultiItemShoppingAction {\n              journeyContinuationId\n            }\n          }\n        }\n        ... on MultiItemSearchContextErrorResponse {\n          ...MultiItemSearchContextErrorResponseFragment\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  mutation MishopSharedUIUpdateProductMutation(\n    $context: ContextInput!\n    $multiItemSessionId: String!\n    $priceToken: String\n    $flights: [FlightNaturalKeyInput!]\n    $activity: ActivityUpdateInput\n  ) {\n    multiItemShopping(context: $context) {\n      updateProduct(sessionId: $multiItemSessionId, priceToken: $priceToken, flights: $flights, activity: $activity) {\n        __typename\n        ... on MultiItemSearchContextCreatedResponse {\n          redirectUrl\n          action {\n            __typename\n            shoppingContext {\n              multiItem {\n                id\n              }\n            }\n            ... on FlightSearchMultiItemShoppingAction {\n              journeyContinuationId\n            }\n          }\n        }\n        ... on MultiItemSearchContextErrorResponse {\n          ...MultiItemSearchContextErrorResponseFragment\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  mutation MishopSharedUIPrepareCheckout(\n    $context: ContextInput!\n    $activities: [ActivityNaturalKeyInput!]\n    $groundTransfers: [GroundTransfersNaturalKeyInput!]\n    $cars: [CarNaturalKeyInput!]\n    $properties: [PropertyNaturalKeyInput!]\n    $flights: [FlightNaturalKeyInput!]\n    $packages: [PackageNaturalKeyInput!]\n    $responseOptions: [PrepareCheckoutResponseOption!]\n    $totalPrice: MoneyInput\n    $cookies: String\n    $checkoutOptions: [CheckoutOptionInput!]\n  ) {\n    prepareCheckout(\n      context: $context\n      activities: $activities\n      groundTransfers: $groundTransfers\n      cars: $cars\n      properties: $properties\n      flights: $flights\n      packages: $packages\n      responseOptions: $responseOptions\n      totalPrice: $totalPrice\n      cookies: $cookies\n      checkoutOptions: $checkoutOptions\n    ) {\n      tripId\n      checkoutUrl\n      failureReason {\n        __typename\n        description\n        message\n        ... on MaxRoomsFailure {\n          groupLinkMessage\n        }\n      }\n    }\n  }\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  mutation MishopSharedUIPrepareCheckoutBySessionId(\n    $context: ContextInput!\n    $multiItemSessionId: String!\n    $cookies: String\n    $checkoutOptions: [CheckoutOptionInput!]\n  ) {\n    prepareCheckoutBySessionId(context: $context, multiItemSessionId: $multiItemSessionId, cookies: $cookies, checkoutOptions: $checkoutOptions) {\n      tripId\n      checkoutUrl\n      failureReason {\n        __typename\n        description\n        message\n        ... on MaxRoomsFailure {\n          groupLinkMessage\n        }\n      }\n    }\n  }\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  mutation MishopSharedUIChangePackageMutation($context: ContextInput!, $multiItemSessionId: String!, $searchCriteria: PackageSearchCriteriaInput!) {\n    multiItemShopping(context: $context) {\n      changePackage(sessionId: $multiItemSessionId, searchCriteria: $searchCriteria) {\n        __typename\n        ... on MultiItemSearchContextCreatedResponse {\n          redirectUrl\n          action {\n            __typename\n            shoppingContext {\n              multiItem {\n                id\n              }\n            }\n          }\n        }\n        ... on MultiItemSearchContextErrorResponse {\n          ...MultiItemSearchContextErrorResponseFragment\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  mutation MishopSharedUISelectPackageMutation($context: ContextInput!, $multiItemSessionId: String!, $packageOfferId: String!) {\n    multiItemShopping(context: $context) {\n      selectPackage(sessionId: $multiItemSessionId, packageOfferId: $packageOfferId) {\n        __typename\n        ... on MultiItemSearchContextCreatedResponse {\n          redirectUrl\n          action {\n            __typename\n            shoppingContext {\n              multiItem {\n                id\n              }\n            }\n          }\n          target\n        }\n        ... on MultiItemSearchContextErrorResponse {\n          ...MultiItemSearchContextErrorResponseFragment\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
import React16, { useMemo } from "react";
import { useMutation } from "@apollo/client";
// src/components/get-default-operation-state.ts
function getDefaultOperationsState(defaultOperationKeys) {
  return defaultOperationKeys.reduce(function (accum, next) {
    return Object.assign(accum, _define_property({}, next, {
      status: "UNKNOWN"
    }));
  }, {});
}
// src/components/operation-failure-dialog.tsx
import React10 from "react";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
// ../internal/src/components/egds-action-dialog-footer/egds-action-dialog-footer.tsx
import React from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkPrimaryButton, UitkTertiaryButton } from "uitk-react-button";
import { UitkDialogFooter } from "uitk-react-dialog";
var fragment = gql(_templateObject());
var _obj;
var buttonComponentMap = (_obj = {}, _define_property(_obj, "PRIMARY" /* PRIMARY */, UitkPrimaryButton), _define_property(_obj, "TERTIARY" /* TERTIARY */, UitkTertiaryButton), _obj);
var isValidButton = function (button) {
  return button.__typename === "PackageUIActionDialogFooterButton" && buttonComponentMap[button.style];
};
var getChildrenButtons = function (data, onDialogClose, track) {
  return data.buttons.filter(isValidButton).map(function (button, index) {
    if (button.__typename !== "PackageUIActionDialogFooterButton") {
      return null;
    }
    var Button = buttonComponentMap[button.style];
    var commonProps = {
      key: "dialog-footer-button-".concat(index),
      analytics: {
        id: button.dialogAction.analytics.referrerId,
        description: button.dialogAction.analytics.linkName,
        callback: function (id, description) {
          return track(id, description);
        }
      }
    };
    switch (button.dialogAction.__typename) {
      case "PackageUIActionDialogFooterButtonCloseAction":
        {
          return /* @__PURE__ */React.createElement(Button, _object_spread_props(_object_spread({}, commonProps), {
            onClick: onDialogClose
          }), button.primary);
        }
      case "PackageUIActionDialogSearchLinkAction":
        {
          var linkProps = {
            href: button.dialogAction.resource.__typename === "HttpURI" ? button.dialogAction.resource.relativePath : void 0,
            target: button.dialogAction.target === "EXTERNAL" /* EXTERNAL */ ? "_blank" : "_self",
            rel: "noopener noreferrer",
            onClick: onDialogClose
          };
          return linkProps.href ? /* @__PURE__ */React.createElement(Button, _object_spread({}, commonProps, linkProps), /* @__PURE__ */React.createElement(React.Fragment, null, button.primary, button.dialogAction.newTabAccessibilityText && /* @__PURE__ */React.createElement("span", {
            className: "is-visually-hidden"
          }, button.dialogAction.newTabAccessibilityText))) : null;
        }
      default:
        return null;
    }
  }).filter(Boolean);
};
var EGDSActionDialogFooter = function (param) {
  var data = param.data,
    onDialogClose = param.onDialogClose;
  var track = useClickTracker();
  var buttons = getChildrenButtons(data, onDialogClose, track);
  switch (data.__typename) {
    case "EGDSInlineDialogFooter":
      return /* @__PURE__ */React.createElement(UitkDialogFooter, {
        stacked: false
      }, buttons);
    case "EGDSStackedDialogFooter":
      return /* @__PURE__ */React.createElement(UitkDialogFooter, {
        stacked: true
      }, buttons);
    default:
      return null;
  }
};
EGDSActionDialogFooter.fragment = fragment;
EGDSActionDialogFooter.displayName = "EGDSActionDialogFooter";
// ../internal/src/components/egds-text/egds-heading.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkHeading } from "uitk-react-text";
var fragment2 = gql2(_templateObject1());
var EGDSHeading = function (param) {
  var headingProps = param.headingProps,
    data = param.data;
  return /* @__PURE__ */React2.createElement(UitkHeading, _object_spread({}, headingProps), data.text);
};
EGDSHeading.fragment = fragment2;
EGDSHeading.displayName = "EGDSHeading";
// ../internal/src/components/egds-text/egds-paragraph.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
var fragment3 = gql3(_templateObject2());
var UitkParagraphSizeMap = {
  1: 1,
  2: 2,
  3: 3
};
var _UitkParagraphSizeMap_size;
var EGDSParagraph = function (param) {
  var _param_data = param.data,
    size = _param_data.size,
    text = _param_data.text;
  return /* @__PURE__ */React3.createElement(UitkParagraph, {
    size: (_UitkParagraphSizeMap_size = UitkParagraphSizeMap[size]) !== null && _UitkParagraphSizeMap_size !== void 0 ? _UitkParagraphSizeMap_size : void 0
  }, text);
};
EGDSParagraph.fragment = fragment3;
EGDSParagraph.displayName = "EGDSParagraph";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkText } from "uitk-react-text";
var fragment4 = gql4(_templateObject3());
var EGDSPlainText = function (param) {
  var textProps = param.textProps,
    data = param.data;
  return /* @__PURE__ */React4.createElement(UitkText, _object_spread({}, textProps), data.text);
};
EGDSPlainText.fragment = fragment4;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment5 = gql5(_templateObject4());
var _obj1;
var UitkTextThemeMap = (_obj1 = {}, _define_property(_obj1, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj1, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj1, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj1, "EMPHASIS" /* EMPHASIS */, "emphasis"), _define_property(_obj1, "PRIMARY" /* PRIMARY */, "emphasis"), _define_property(_obj1, "SECONDARY" /* SECONDARY */, "default"), _define_property(_obj1, "INVERSE" /* INVERSE */, "inverse"), _obj1);
var _obj2;
var UitkTextWeightMap = (_obj2 = {}, _define_property(_obj2, "BOLD" /* BOLD */, "bold"), _define_property(_obj2, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj2, "REGULAR" /* REGULAR */, "regular"), _obj2);
var EGDSStylizedText = function (props) {
  var data = props.data,
    textProps = props.textProps;
  var text = data.text,
    theme = data.theme,
    weight = data.weight,
    decorative = data.decorative;
  var textTheme = theme ? UitkTextThemeMap[theme] : void 0;
  var textWeight = weight ? UitkTextWeightMap[weight] : void 0;
  switch (decorative) {
    case "LINE_THROUGH" /* LINE_THROUGH */:
      var _textProps, _textProps1, _textProps2;
      var _textProps_theme;
      return /* @__PURE__ */React5.createElement("s", null, /* @__PURE__ */React5.createElement(UitkText2, {
        size: (_textProps = textProps) === null || _textProps === void 0 ? void 0 : _textProps.size,
        theme: (_textProps_theme = (_textProps1 = textProps) === null || _textProps1 === void 0 ? void 0 : _textProps1.theme) !== null && _textProps_theme !== void 0 ? _textProps_theme : textTheme,
        weight: textWeight,
        inline: (_textProps2 = textProps) === null || _textProps2 === void 0 ? void 0 : _textProps2.inline
      }, text));
    default:
      var _textProps3, _textProps4, _textProps5;
      var _textProps_theme1;
      return /* @__PURE__ */React5.createElement(UitkText2, {
        size: (_textProps3 = textProps) === null || _textProps3 === void 0 ? void 0 : _textProps3.size,
        theme: (_textProps_theme1 = (_textProps4 = textProps) === null || _textProps4 === void 0 ? void 0 : _textProps4.theme) !== null && _textProps_theme1 !== void 0 ? _textProps_theme1 : textTheme,
        weight: textWeight,
        inline: (_textProps5 = textProps) === null || _textProps5 === void 0 ? void 0 : _textProps5.inline
      }, text);
  }
};
EGDSStylizedText.fragment = fragment5;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-text.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
// ../internal/src/components/egds-link/egds-standard-link.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { UitkText as UitkText3 } from "uitk-react-text";
var fragment6 = gql6(_templateObject5());
var _obj3;
var UILinkTargetMap = (_obj3 = {}, _define_property(_obj3, "EXTERNAL" /* EXTERNAL */, "_blank" /* EXTERNAL */), _define_property(_obj3, "INTERNAL" /* INTERNAL */, "_self" /* INTERNAL */), _obj3);
var EGDSStandardLink = function (param) {
  var data = param.data,
    inline = param.inline,
    iconSize = param.iconSize;
  var action = data.action,
    text = data.text,
    icon = data.icon,
    iconPosition = data.iconPosition;
  var analytics = action.analytics,
    resource = action.resource,
    target = action.target,
    accessibility = action.accessibility;
  var clickTracker = useClickTracker2();
  var onClick = React6.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  return /* @__PURE__ */React6.createElement(UitkLink, {
    onClickCapture: onClick,
    inline: inline !== null && inline !== void 0 ? inline : true
  }, /* @__PURE__ */React6.createElement("a", {
    target: UILinkTargetMap[target],
    href: resource.value
  }, icon && iconPosition !== "TRAILING" /* TRAILING */ && /* @__PURE__ */React6.createElement(UitkIcon, {
    name: icon.id,
    size: iconSize
  }), text, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React6.createElement(UitkIcon, {
    name: icon.id,
    size: iconSize
  }), accessibility && /* @__PURE__ */React6.createElement(UitkText3, {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.displayName = "EGDSStandardLink";
EGDSStandardLink.fragment = fragment6;
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText as UitkText4 } from "uitk-react-text";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-item.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
var fragment7 = gql7(_templateObject6(), EGDSStylizedText.fragment, EGDSPlainText.fragment);
var EGDSSpannableTextItem = function (param) {
  var data = param.data,
    textProps = param.textProps;
  switch (data.__typename) {
    case "EGDSStylizedText":
      return /* @__PURE__ */React7.createElement(EGDSStylizedText, {
        data: data,
        textProps: textProps
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React7.createElement(EGDSPlainText, {
        data: data,
        textProps: textProps
      });
    default:
      return null;
  }
};
EGDSSpannableTextItem.fragment = fragment7;
EGDSSpannableTextItem.displayName = "EGDSSpannableTextItem";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment8 = gql8(_templateObject7(), EGDSSpannableTextItem.fragment);
var spannableSpacing = {
  margin: {
    inlineend: "one"
  }
};
var EGDSSpannableText = function (props) {
  var data = props.data,
    textProps = _object_without_properties(props, ["data"]);
  if (data.inlineContent.length === 0) {
    return /* @__PURE__ */React8.createElement(UitkText4, _object_spread({}, textProps), data.text);
  }
  return /* @__PURE__ */React8.createElement(React8.Fragment, null, data.inlineContent.map(function (item, index) {
    return /* @__PURE__ */React8.createElement(UitkSpacing, _object_spread_props(_object_spread({}, spannableSpacing), {
      key: "spannable-text-item-".concat(index)
    }), /* @__PURE__ */React8.createElement(EGDSSpannableTextItem, _object_spread({
      data: item
    }, textProps)));
  }));
};
EGDSSpannableText.fragment = fragment8;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment9 = gql9(_templateObject8(), EGDSHeading.fragment, EGDSParagraph.fragment, EGDSPlainText.fragment, EGDSStandardLink.fragment, EGDSStylizedText.fragment, EGDSSpannableText.fragment);
var EGDSText = function (param) {
  var data = param.data,
    headingProps = param.headingProps,
    textProps = param.textProps;
  switch (data.__typename) {
    case "EGDSHeading":
      return /* @__PURE__ */React9.createElement(EGDSHeading, {
        data: data,
        headingProps: headingProps
      });
    case "EGDSParagraph":
      return /* @__PURE__ */React9.createElement(EGDSParagraph, {
        data: data
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React9.createElement(EGDSPlainText, {
        data: data,
        textProps: textProps
      });
    case "EGDSStandardLink":
      return /* @__PURE__ */React9.createElement(EGDSStandardLink, {
        data: data
      });
    case "EGDSStylizedText":
      return /* @__PURE__ */React9.createElement(EGDSStylizedText, {
        data: data,
        textProps: textProps
      });
    case "EGDSSpannableText":
      return /* @__PURE__ */React9.createElement(EGDSSpannableText, {
        data: data,
        textProps: textProps
      });
    default:
      return null;
  }
};
EGDSText.fragment = fragment9;
EGDSText.displayName = "EGDSText";
// src/components/operation-failure-dialog.tsx
import { UitkDialog, UitkDialogContent } from "uitk-react-dialog";
import { UitkSheetTransition } from "uitk-react-sheet";
var OperationFailureDialog = function (param) {
  var useRegisterOperations = param.useRegisterOperations;
  var _failureDialog_dialog, _failureDialog;
  var track = useClickTracker3();
  var _useDialog = _sliced_to_array(useDialog("operation-failure-dialog"), 3),
    isDialogOpen = _useDialog[0],
    dialogActions = _useDialog[1],
    ErrorDialogComponent = _useDialog[2];
  var _React10_useState = _sliced_to_array(React10.useState(), 2),
    failureDialog = _React10_useState[0],
    setFailureDialog = _React10_useState[1];
  var onDialogClose = React10.useCallback(function () {
    var _failureDialog;
    if ((_failureDialog = failureDialog) === null || _failureDialog === void 0 ? void 0 : _failureDialog.dialog.closeAnalytics) {
      track(failureDialog.dialog.closeAnalytics.referrerId, failureDialog.dialog.closeAnalytics.linkName);
    }
    dialogActions.closeDialog();
  }, [track, dialogActions, (_failureDialog = failureDialog) === null || _failureDialog === void 0 ? void 0 : (_failureDialog_dialog = _failureDialog.dialog) === null || _failureDialog_dialog === void 0 ? void 0 : _failureDialog_dialog.closeAnalytics]);
  useRegisterOperations(dialogActions.openDialog, setFailureDialog);
  if (!failureDialog) {
    return null;
  }
  return /* @__PURE__ */React10.createElement(UitkSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React10.createElement(ErrorDialogComponent, null, /* @__PURE__ */React10.createElement(UitkDialog, {
    dialogShow: isDialogOpen,
    returnFocusOnClose: true
  }, /* @__PURE__ */React10.createElement(UitkDialogContent, null, /* @__PURE__ */React10.createElement(EGDSParagraph, {
    data: _object_spread_props(_object_spread({}, failureDialog.content), {
      size: 2
    })
  })), /* @__PURE__ */React10.createElement(EGDSActionDialogFooter, {
    data: failureDialog.dialog.footer,
    onDialogClose: onDialogClose
  }))));
};
// src/components/session-operations-provider/context/session-operations-context.ts
import React11 from "react";
// src/components/types.ts
var MishopOperationFailureType = /* @__PURE__ */function (MishopOperationFailureType2) {
  MishopOperationFailureType2["GRAPHQL"] = "GRAPHQL";
  MishopOperationFailureType2["NO_PROVIDER"] = "NO_PROVIDER";
  MishopOperationFailureType2["UNKNOWN"] = "UNKNOWN";
  return MishopOperationFailureType2;
}(MishopOperationFailureType || {});
// src/components/session-operations-provider/context/get-default-operation.ts
function getDefaultOperation(operationName) {
  return function () {
    return Promise.resolve({
      success: false,
      failureReason: "no SessionOperationsProvider in tree found while calling ".concat(operationName),
      failure: {
        type: "NO_PROVIDER" /* NO_PROVIDER */
      }
    });
  };
}
// src/components/session-operations-provider/context/session-operations-context.ts
var defaultOperationsContext = {
  addProduct: getDefaultOperation("addProduct"),
  updateProduct: getDefaultOperation("updateProduct"),
  removeProduct: getDefaultOperation("removeProduct"),
  replaceProduct: getDefaultOperation("replaceProduct"),
  changeSelectedProduct: getDefaultOperation("changeSelectedProduct")
};
var SessionOperationsContext = React11.createContext(_object_spread_props(_object_spread({}, defaultOperationsContext), {
  state: getDefaultOperationsState(Object.keys(defaultOperationsContext))
}));
// src/components/session-operations-provider/hooks/use-session-operations-failure-dialog.ts
import React13 from "react";
// src/components/session-operations-provider/hooks/use-session-operations.ts
import React12 from "react";
function useSessionOperations() {
  var _React12_useContext = React12.useContext(SessionOperationsContext),
    addProduct2 = _React12_useContext.addProduct,
    updateProduct2 = _React12_useContext.updateProduct,
    removeProduct2 = _React12_useContext.removeProduct,
    replaceProduct2 = _React12_useContext.replaceProduct,
    changeSelectedProduct2 = _React12_useContext.changeSelectedProduct,
    rest = _object_without_properties(_React12_useContext, ["addProduct", "updateProduct", "removeProduct", "replaceProduct", "changeSelectedProduct"]);
  return _object_spread({
    addProduct: React12.useCallback(addProduct2, []),
    updateProduct: React12.useCallback(updateProduct2, []),
    removeProduct: React12.useCallback(removeProduct2, []),
    replaceProduct: React12.useCallback(replaceProduct2, []),
    changeSelectedProduct: React12.useCallback(changeSelectedProduct2, [])
  }, rest);
}
// src/components/session-operations-provider/hooks/use-session-operations-failure-dialog.ts
function useSessionOperationsFailureDialog(openDialog, setFailureDialog) {
  var state = useSessionOperations().state;
  React13.useEffect(function () {
    if (state.addProduct.status === "SUCCESS") {
      var addProducts = state.addProduct.result.data.multiItemShopping.addProducts;
      if (addProducts.__typename === "MultiItemSearchContextErrorResponse" && addProducts.failureDialog) {
        setFailureDialog(addProducts.failureDialog);
        openDialog();
      }
    }
  }, [state.addProduct]);
  React13.useEffect(function () {
    if (state.removeProduct.status === "SUCCESS") {
      var removeProducts = state.removeProduct.result.data.multiItemShopping.removeProducts;
      if (removeProducts.__typename === "MultiItemSearchContextErrorResponse" && removeProducts.failureDialog) {
        setFailureDialog(removeProducts.failureDialog);
        openDialog();
      }
    }
  }, [state.removeProduct]);
  React13.useEffect(function () {
    if (state.replaceProduct.status === "SUCCESS") {
      var selectProducts = state.replaceProduct.result.data.multiItemShopping.selectProducts;
      if (selectProducts.__typename === "MultiItemSearchContextErrorResponse" && selectProducts.failureDialog) {
        setFailureDialog(selectProducts.failureDialog);
        openDialog();
      }
    }
  }, [state.replaceProduct]);
  React13.useEffect(function () {
    if (state.updateProduct.status === "SUCCESS") {
      var _state_updateProduct_result_data_multiItemShopping = state.updateProduct.result.data.multiItemShopping,
        updateProduct2 = _state_updateProduct_result_data_multiItemShopping.updateProduct;
      if (updateProduct2.__typename === "MultiItemSearchContextErrorResponse" && updateProduct2.failureDialog) {
        setFailureDialog(updateProduct2.failureDialog);
        openDialog();
      }
    }
  }, [state.updateProduct]);
}
// src/components/register-operation.ts
function registerOperation(params) {
  return function executeOperation(operation, updateState, variables, event) {
    updateState(function (prevState) {
      return _object_spread_props(_object_spread({}, prevState), _define_property({}, params.operationName, {
        status: "IN_PROGRESS",
        event: event
      }));
    });
    return operation({
      variables: variables
    }).then(function (response) {
      if (response.errors) {
        var error = {
          failureReason: "".concat(params.operationName, " failed with graphql error(s)"),
          failure: {
            type: "GRAPHQL" /* GRAPHQL */,
            errors: response.errors
          }
        };
        updateState(function (prevState) {
          return _object_spread_props(_object_spread({}, prevState), _define_property({}, params.operationName, {
            status: "FAILURE",
            event: event,
            error: error
          }));
        });
        return _object_spread({
          success: false
        }, error);
      }
      if (!response.data) {
        return Promise.reject(new Error("".concat(params.operationName, " returned null data")));
      }
      updateState(function (prevState) {
        return _object_spread_props(_object_spread({}, prevState), _define_property({}, params.operationName, {
          status: "SUCCESS",
          event: event,
          result: response
        }));
      });
      return _object_spread({
        success: true
      }, response);
    }).catch(function (error) {
      var failureReason = "unexpected error encountered while calling ".concat(params.operationName);
      var completeErrorMessage = "".concat(failureReason, ": ").concat(_instanceof(error, Error) ? error.message : error);
      var structuredError = {
        failureReason: failureReason,
        failure: {
          type: "UNKNOWN" /* UNKNOWN */,
          error: new Error(completeErrorMessage)
        }
      };
      updateState(function (prevState) {
        return _object_spread_props(_object_spread({}, prevState), _define_property({}, params.operationName, {
          status: "FAILURE",
          event: event,
          error: structuredError
        }));
      });
      return _object_spread({
        success: false
      }, structuredError);
    });
  };
}
// src/components/session-operations-provider/operations/add-product/add-product.ts
var addProduct = registerOperation({
  operationName: "addProduct"
});
// src/components/session-operations-provider/operations/add-product/mutation/add-product-mutation.ts
import { gql as gql14 } from "@apollo/client";
// src/components/operations-common/__fragments/multi-item-search-context-error-response.ts
import { gql as gql13 } from "@apollo/client";
// ../internal/src/components/package-ui-empty-state-error/package-ui-empty-state-error.tsx
import React15 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
// ../internal/src/components/egds-icon/egds-icon.tsx
import React14 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkIcon as UitkIcon2, UitkIconSize } from "uitk-react-icons";
var fragment10 = gql10(_templateObject9());
var _obj4;
var SPOTLIGHT_MAP = (_obj4 = {}, _define_property(_obj4, "INFO" /* INFO */, "info"), _define_property(_obj4, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj4, "STANDARD" /* STANDARD */, "standard"), _define_property(_obj4, "WARNING" /* WARNING */, "warning"), _obj4);
var EGDSIcon = function (param) {
  var data = param.data,
    defaultIconSize = param.defaultIconSize,
    defaultIconTheme = param.defaultIconTheme,
    defaultIconSpotLight = param.defaultIconSpotLight;
  var description = data.description,
    id = data.id,
    size = data.size,
    title = data.title,
    theme = data.theme,
    withBackground = data.withBackground,
    spotLight = data.spotLight;
  var _ref;
  return /* @__PURE__ */React14.createElement(UitkIcon2, {
    description: description,
    id: id,
    name: id,
    size: size ? UitkIconSize[size] : defaultIconSize,
    title: title !== null && title !== void 0 ? title : void 0,
    theme: theme !== null && theme !== void 0 ? theme : defaultIconTheme,
    shadow: Boolean(withBackground),
    spotlight: (_ref = spotLight && SPOTLIGHT_MAP[spotLight] || defaultIconSpotLight) !== null && _ref !== void 0 ? _ref : void 0
  });
};
EGDSIcon.displayName = "EGDSIcon";
EGDSIcon.fragment = fragment10;
// ../internal/src/components/package-ui-empty-state-error/package-ui-empty-state-error.tsx
var fragment11 = gql11(_templateObject10(), EGDSIcon.fragment, EGDSText.fragment, EGDSHeading.fragment);
var PackageUIEmptyStateError = function (param) {
  var _param_data = param.data,
    icon = _param_data.icon,
    primary = _param_data.primary,
    secondaries = _param_data.secondaries;
  return /* @__PURE__ */React15.createElement(UitkLayoutFlex, {
    direction: "column",
    alignItems: "center"
  }, /* @__PURE__ */React15.createElement(EGDSIcon, {
    data: icon,
    defaultIconSize: UitkIconSize2.XLARGE
  }), /* @__PURE__ */React15.createElement(UitkSpacing2, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(EGDSHeading, {
    data: primary,
    headingProps: {
      size: 5
    }
  }))), secondaries.length > 0 && /* @__PURE__ */React15.createElement(UitkSpacing2, {
    margin: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React15.createElement("div", null, secondaries.map(function (secondary, index) {
    return /* @__PURE__ */React15.createElement(EGDSText, {
      data: secondary,
      textProps: {
        size: 300
      },
      key: index
    });
  }))));
};
PackageUIEmptyStateError.fragment = fragment11;
PackageUIEmptyStateError.displayName = "PackageUIEmptyStateErrorFragment";
// src/components/operations-common/__fragments/mishop-ui-operation-failure-dialog.ts
import { gql as gql12 } from "@apollo/client";
var MishopUIOperationFailureDialogFragment = gql12(_templateObject11(), EGDSActionDialogFooter.fragment);
// src/components/operations-common/__fragments/multi-item-search-context-error-response.ts
var MultiItemSearchContextErrorResponseFragment = gql13(_templateObject12(), MishopUIOperationFailureDialogFragment, PackageUIEmptyStateError.fragment);
// src/components/session-operations-provider/operations/add-product/mutation/add-product-mutation.ts
var AddProductMutation = gql14(_templateObject13(), MultiItemSearchContextErrorResponseFragment);
// src/components/session-operations-provider/operations/change-selected-product/change-selected-product.ts
var changeSelectedProduct = registerOperation({
  operationName: "changeSelectedProduct"
});
// src/components/session-operations-provider/operations/change-selected-product/mutation/change-selected-product-mutation.ts
import { gql as gql15 } from "@apollo/client";
var ChangeSelectedProductMutation = gql15(_templateObject14());
// src/components/session-operations-provider/operations/remove-product/remove-product.ts
var removeProduct = registerOperation({
  operationName: "removeProduct"
});
// src/components/session-operations-provider/operations/remove-product/mutation/remove-product-mutation.ts
import { gql as gql16 } from "@apollo/client";
var RemoveProductMutation = gql16(_templateObject15(), MultiItemSearchContextErrorResponseFragment);
// src/components/session-operations-provider/operations/replace-product/replace-product.ts
var replaceProduct = registerOperation({
  operationName: "replaceProduct"
});
// src/components/session-operations-provider/operations/replace-product/mutation/replace-product-mutation.ts
import { gql as gql17 } from "@apollo/client";
var ReplaceProductMutation = gql17(_templateObject16(), MultiItemSearchContextErrorResponseFragment);
// src/components/session-operations-provider/operations/update-product/update-product.ts
var updateProduct = registerOperation({
  operationName: "updateProduct"
});
// src/components/session-operations-provider/operations/update-product/mutation/update-product-mutation.ts
import { gql as gql18 } from "@apollo/client";
var UpdateProductMutation = gql18(_templateObject17(), MultiItemSearchContextErrorResponseFragment);
// src/components/session-operations-provider/session-operations-provider.tsx
var SessionOperationsProvider = function (param) {
  var children = param.children,
    _param_autoRenderFailureDialog = param.autoRenderFailureDialog,
    autoRenderFailureDialog = _param_autoRenderFailureDialog === void 0 ? false : _param_autoRenderFailureDialog;
  var _useMutation = _sliced_to_array(useMutation(AddProductMutation), 1),
    addProductMutation = _useMutation[0];
  var _useMutation1 = _sliced_to_array(useMutation(UpdateProductMutation), 1),
    updateProductMutation = _useMutation1[0];
  var _useMutation2 = _sliced_to_array(useMutation(RemoveProductMutation), 1),
    removeProductMutation = _useMutation2[0];
  var _useMutation3 = _sliced_to_array(useMutation(ReplaceProductMutation), 1),
    replaceProductMutation = _useMutation3[0];
  var _useMutation4 = _sliced_to_array(useMutation(ChangeSelectedProductMutation), 1),
    changeSelectedProductMutation = _useMutation4[0];
  var _React16_useState = _sliced_to_array(React16.useState(getDefaultOperationsState(Object.keys(defaultOperationsContext))), 2),
    state = _React16_useState[0],
    updateState = _React16_useState[1];
  return /* @__PURE__ */React16.createElement(SessionOperationsContext.Provider, {
    value: useMemo(function () {
      return {
        addProduct: function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return addProduct.apply(void 0, [addProductMutation, updateState].concat(_to_consumable_array(args)));
        },
        updateProduct: function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return updateProduct.apply(void 0, [updateProductMutation, updateState].concat(_to_consumable_array(args)));
        },
        removeProduct: function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return removeProduct.apply(void 0, [removeProductMutation, updateState].concat(_to_consumable_array(args)));
        },
        replaceProduct: function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return replaceProduct.apply(void 0, [replaceProductMutation, updateState].concat(_to_consumable_array(args)));
        },
        changeSelectedProduct: function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return changeSelectedProduct.apply(void 0, [changeSelectedProductMutation, updateState].concat(_to_consumable_array(args)));
        },
        state: state
      };
    }, [addProductMutation, updateProductMutation, removeProductMutation, replaceProductMutation, changeSelectedProductMutation, state])
  }, autoRenderFailureDialog && /* @__PURE__ */React16.createElement(OperationFailureDialog, {
    useRegisterOperations: useSessionOperationsFailureDialog
  }), children);
};
// src/components/prepare-checkout-operations-provider/prepare-checkout-operations-provider.tsx
import React18, { useMemo as useMemo2 } from "react";
import { useMutation as useMutation2 } from "@apollo/client";
// src/components/prepare-checkout-operations-provider/context/prepare-checkout-operations-context.ts
import React17 from "react";
// src/components/prepare-checkout-operations-provider/context/get-default-operation.ts
function getDefaultOperation2(operationName) {
  return function () {
    return Promise.resolve({
      success: false,
      failureReason: "no PrepareCheckoutOperationsProvider in tree found while calling ".concat(operationName),
      failure: {
        type: "NO_PROVIDER" /* NO_PROVIDER */
      }
    });
  };
}
// src/components/prepare-checkout-operations-provider/context/prepare-checkout-operations-context.ts
var defaultOperationsContext2 = {
  prepareCheckoutBySessionId: getDefaultOperation2("prepareCheckoutBySessionId"),
  prepareCheckout: getDefaultOperation2("prepareCheckout")
};
var PrepareCheckoutOperationsContext = React17.createContext(_object_spread_props(_object_spread({}, defaultOperationsContext2), {
  state: getDefaultOperationsState(Object.keys(defaultOperationsContext2))
}));
// src/components/prepare-checkout-operations-provider/operations/prepare-checkout/mutation/prepare-checkout.ts
import { gql as gql19 } from "@apollo/client";
var PrepareCheckoutMutation = gql19(_templateObject18());
// src/components/prepare-checkout-operations-provider/operations/prepare-checkout/prepare-checkout.ts
var prepareCheckout = registerOperation({
  operationName: "prepareCheckout"
});
// src/components/prepare-checkout-operations-provider/operations/prepare-checkout-by-session-id/mutation/prepare-checkout-by-session-id.ts
import { gql as gql20 } from "@apollo/client";
var PrepareCheckoutBySessionIdMutation = gql20(_templateObject19());
// src/components/prepare-checkout-operations-provider/operations/prepare-checkout-by-session-id/prepare-checkout-by-session-id.ts
var prepareCheckoutBySessionId = registerOperation({
  operationName: "prepareCheckoutBySessionId"
});
// src/components/prepare-checkout-operations-provider/prepare-checkout-operations-provider.tsx
var PrepareCheckoutOperationsProvider = function (param) {
  var children = param.children;
  var _useMutation2 = _sliced_to_array(useMutation2(PrepareCheckoutBySessionIdMutation), 1),
    prepareCheckoutBySessionIdMutation = _useMutation2[0];
  var _useMutation21 = _sliced_to_array(useMutation2(PrepareCheckoutMutation), 1),
    prepareCheckoutMutation = _useMutation21[0];
  var _React18_useState = _sliced_to_array(React18.useState(getDefaultOperationsState(Object.keys(defaultOperationsContext2))), 2),
    state = _React18_useState[0],
    updateState = _React18_useState[1];
  return /* @__PURE__ */React18.createElement(PrepareCheckoutOperationsContext.Provider, {
    value: useMemo2(function () {
      return {
        prepareCheckoutBySessionId: function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return prepareCheckoutBySessionId.apply(void 0, [prepareCheckoutBySessionIdMutation, updateState].concat(_to_consumable_array(args)));
        },
        prepareCheckout: function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return prepareCheckout.apply(void 0, [prepareCheckoutMutation, updateState].concat(_to_consumable_array(args)));
        },
        state: state
      };
    }, [prepareCheckoutBySessionIdMutation, prepareCheckoutMutation, state])
  }, children);
};
// src/components/prepare-checkout-operations-provider/hooks/use-prepare-checkout-operations.ts
import React19 from "react";
function usePrepareCheckoutOperations() {
  var _React19_useContext = React19.useContext(PrepareCheckoutOperationsContext),
    prepareCheckout2 = _React19_useContext.prepareCheckout,
    prepareCheckoutBySessionId2 = _React19_useContext.prepareCheckoutBySessionId,
    rest = _object_without_properties(_React19_useContext, ["prepareCheckout", "prepareCheckoutBySessionId"]);
  return _object_spread({
    prepareCheckout: React19.useCallback(prepareCheckout2, []),
    prepareCheckoutBySessionId: React19.useCallback(prepareCheckoutBySessionId2, [])
  }, rest);
}
// src/components/package-operations-provider/package-operations-provider.tsx
import React23, { useMemo as useMemo3 } from "react";
import { useMutation as useMutation3 } from "@apollo/client";
// src/components/package-operations-provider/context/package-operations-context.ts
import React20 from "react";
// src/components/package-operations-provider/context/get-default-operation.ts
function getDefaultOperation3(operationName) {
  return function () {
    return Promise.resolve({
      success: false,
      failureReason: "no PackageOperationsProvider in tree found while calling ".concat(operationName),
      failure: {
        type: "NO_PROVIDER" /* NO_PROVIDER */
      }
    });
  };
}
// src/components/package-operations-provider/context/package-operations-context.ts
var defaultOperationsContext3 = {
  selectPackage: getDefaultOperation3("selectPackage"),
  changePackage: getDefaultOperation3("changePackage")
};
var PackageOperationsContext = React20.createContext(_object_spread_props(_object_spread({}, defaultOperationsContext3), {
  state: getDefaultOperationsState(Object.keys(defaultOperationsContext3))
}));
// src/components/package-operations-provider/hooks/use-package-operations-failure-dialog.ts
import React22 from "react";
// src/components/package-operations-provider/hooks/use-package-operations.ts
import React21 from "react";
function usePackageOperations() {
  var _React21_useContext = React21.useContext(PackageOperationsContext),
    changePackage2 = _React21_useContext.changePackage,
    selectPackage2 = _React21_useContext.selectPackage,
    rest = _object_without_properties(_React21_useContext, ["changePackage", "selectPackage"]);
  return _object_spread({
    changePackage: React21.useCallback(changePackage2, []),
    selectPackage: React21.useCallback(selectPackage2, [])
  }, rest);
}
// src/components/package-operations-provider/hooks/use-package-operations-failure-dialog.ts
function usePackageOperationsFailureDialog(openDialog, setFailureDialog) {
  var state = usePackageOperations().state;
  React22.useEffect(function () {
    if (state.selectPackage.status === "SUCCESS") {
      var _state_selectPackage_result_data_multiItemShopping = state.selectPackage.result.data.multiItemShopping,
        selectPackage2 = _state_selectPackage_result_data_multiItemShopping.selectPackage;
      if (selectPackage2.__typename === "MultiItemSearchContextErrorResponse" && selectPackage2.failureDialog) {
        setFailureDialog(selectPackage2.failureDialog);
        openDialog();
      }
    }
  }, [state.selectPackage]);
  React22.useEffect(function () {
    if (state.changePackage.status === "SUCCESS") {
      var _state_changePackage_result_data_multiItemShopping = state.changePackage.result.data.multiItemShopping,
        changePackage2 = _state_changePackage_result_data_multiItemShopping.changePackage;
      if (changePackage2.__typename === "MultiItemSearchContextErrorResponse" && changePackage2.failureDialog) {
        setFailureDialog(changePackage2.failureDialog);
        openDialog();
      }
    }
  }, [state.changePackage]);
}
// src/components/package-operations-provider/operations/change-package/change-package.ts
var changePackage = registerOperation({
  operationName: "changePackage"
});
// src/components/package-operations-provider/operations/change-package/mutation/change-package-mutation.ts
import { gql as gql21 } from "@apollo/client";
var ChangePackageMutation = gql21(_templateObject20(), MultiItemSearchContextErrorResponseFragment);
// src/components/package-operations-provider/operations/select-package/select-package.ts
var selectPackage = registerOperation({
  operationName: "selectPackage"
});
// src/components/package-operations-provider/operations/select-package/mutation/select-package-mutation.ts
import { gql as gql22 } from "@apollo/client";
var SelectPackageMutation = gql22(_templateObject21(), MultiItemSearchContextErrorResponseFragment);
// src/components/package-operations-provider/package-operations-provider.tsx
var PackageOperationsProvider = function (param) {
  var children = param.children,
    _param_autoRenderFailureDialog = param.autoRenderFailureDialog,
    autoRenderFailureDialog = _param_autoRenderFailureDialog === void 0 ? false : _param_autoRenderFailureDialog;
  var _useMutation3 = _sliced_to_array(useMutation3(SelectPackageMutation), 1),
    selectPackageMutation = _useMutation3[0];
  var _useMutation31 = _sliced_to_array(useMutation3(ChangePackageMutation), 1),
    changePackageMutation = _useMutation31[0];
  var _React23_useState = _sliced_to_array(React23.useState(getDefaultOperationsState(Object.keys(defaultOperationsContext3))), 2),
    state = _React23_useState[0],
    updateState = _React23_useState[1];
  return /* @__PURE__ */React23.createElement(PackageOperationsContext.Provider, {
    value: useMemo3(function () {
      return {
        selectPackage: function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return selectPackage.apply(void 0, [selectPackageMutation, updateState].concat(_to_consumable_array(args)));
        },
        changePackage: function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return changePackage.apply(void 0, [changePackageMutation, updateState].concat(_to_consumable_array(args)));
        },
        state: state
      };
    }, [selectPackageMutation, changePackageMutation, state])
  }, autoRenderFailureDialog && /* @__PURE__ */React23.createElement(OperationFailureDialog, {
    useRegisterOperations: usePackageOperationsFailureDialog
  }), children);
};
export { MishopOperationFailureType, PackageOperationsProvider, PrepareCheckoutOperationsProvider, SelectPackageMutation, SessionOperationsProvider, usePackageOperations, usePrepareCheckoutOperations, useSessionOperations };